import Adjust from "@adjustcom/adjust-web-sdk";
import { adjustTrackEvent } from "@/lobby_common/utils/eventFunction";
const baset = window.BASEAPI;
import {
  getLocalStorage,
  setLocalStorage,
  removeLocalStorage,
} from "@/lobby_common/utils/auth";
import {
  facebookLogin,
  googleLoginService,
  tronLoginService,
} from "../api/user";
import Store from "@/lobby_common/store/index";
import Bus from "./bus.js";
import { encode } from "js-base64";
export const intAdjustSDK = (config) => {
  // 初始化adjust
  if (config?.appToken) {
    console.log(config, "config------------");
    Adjust.initSdk({
      appToken: config.appToken, // required
      environment: config.environment, // required, 'production' or 'sandbox' in case you are testing SDK locally with your web app
      attributionCallback: function (e, attribution) {
          if (!attribution.adid) {
            removeLocalStorage("adjust_adid");
          } else {
            setLocalStorage("adjust_adid", attribution.adid);
            adjustTrackEvent({ eventToken: "contentView" });
          }
      },
      logLevel: "verbose", // optional, default is 'error', other options are 'none', 'error', 'warning', 'info', 'verbose'
      logOutput: "#output", // optional, outputs logs from sdk into provided container
    });
    getAdid();
    // const timer = setTimeout(() => {
    //   const attribution = Adjust.getAttribution() || {}
    //   console.log(attribution, 'attribution')
    //   if(attribution.adid) {
    //     setLocalStorage('adjust_adid', attribution.adid)
    //   } else {
    //     removeLocalStorage('adjust_adid')
    //   }
    //   clearTimeout(timer);
    // }, 2000);
  } else {
    adjustTrackEvent({ eventToken: "contentView" });
  }
};
let flag = 0;
export const getAdid = async () => {
  // const attribution = Adjust.getAttribution() || {};
  let attribution = {};
  try {
    attribution = await Adjust.waitForAttribution();
  } catch (error) {
    console.log(error)
  }
  if (!attribution.adid) {
    removeLocalStorage("adjust_adid");
    flag += 1;
    if (flag < 30) {
      setTimeout(async () => {
        await getAdid();
      }, 1000);
    }
  } else {
    setLocalStorage("adjust_adid", attribution.adid);
    adjustTrackEvent({ eventToken: "contentView" });
  }
};

export const intFbSDK = () => {
  try {
    // eslint-disable-next-line no-undef
    if (FB) {
      // eslint-disable-next-line no-undef
      FB.init({
        appId: baset.facebook_js_sdk_key,
        status: true,
        xfbml: true,
        version: "v14.0",
      });
    }
  } catch (error) {
    // console.log(error, "-----intFbSDK");
  }
};

// export const fbShare = async (fun, inviteCode) => {
//   // console.log(window.location.protocol + "//" + window.location.host, "======url======");
//   try {
//     // eslint-disable-next-line no-undef
//     if (FB) {
//       let obj = {};
//       if (!inviteCode) {
//         // eslint-disable-next-line no-undef
//         const { data, code } = await inviteAccount();
//         obj = { data, code };
//       } else {
//         obj = { data: { inviteCode: inviteCode }, code: 0 };
//       }
//       const { data, code } = obj;
//       if (code === 0) {
//         const urlStr =
//           window.location.protocol +
//           "//" +
//           window.location.host +
//           "/home?uid=" +
//           data.inviteCode;
//         // eslint-disable-next-line no-undef
//         FB.ui(
//           { display: "popup", method: "share", href: urlStr },
//           function (response) {
//             // 返回结果
//             fun && fun(response);
//           }
//         );
//       }
//     }
//   } catch (error) {
//     // console.log(error, "-----fbShare");
//   }
// };

export function dataURItoBlob(dataURI) {
  var byteString = atob(dataURI.split(",")[1]);
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
}

export const fbShareBySdk = async (obj = {}, fun) => {
  try {
    // eslint-disable-next-line no-undef
    if (FB) {
      const pars = {
        display: "popup",
        method: "feed",
        ...obj,
      };
      console.log(pars);
      // eslint-disable-next-line no-undef
      FB.ui(pars, function (response) {
        // 返回结果
        fun && fun(response);
      });
    }
  } catch (error) {}
};

export const fbLogin = async () => {
  const fbGetme = async (opt) => {
    const { code, data } = await facebookLogin({
      access_token: opt.token,
      fb_id: opt.id,
      coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
    });
    if (code === 0) {
      Store.commit("setTaken", {
        accessToken: data.token,
        refreshToken: data.refreshToken,
      });
      Store.dispatch("getUserInfo");
      Store.commit("setPopBox", { show: false, views: null });
      if (data.is_register) {
        Bus.$emit("loginSuccess", {
          type: "register",
          event: "fb_register",
          ...data,
        });
      } else {
        Bus.$emit("loginSuccess", {
          type: "login",
          event: "fb_login",
          ...data,
        });
      }

      setTimeout(() => {
        Bus.$emit("reload");
      }, 300);
    } else {
      //
    }
  };

  try {
    // eslint-disable-next-line no-undef
    FB.getLoginStatus(function (response) {
      // Called after the JS SDK has been initialized.
      // console.log(response, "------getLoginStatus--------");
      if (response.status === "connected") {
        // eslint-disable-next-line no-undef
        // fbGetme(response.authResponse.accessToken);
        fbGetme({
          token: response.authResponse.accessToken,
          id: response.authResponse.userID,
        });
      } else {
        // eslint-disable-next-line no-undef
        FB.login(function (res) {
          if (res.status === "connected") {
            // Logged into your webpage and Facebook.
            fbGetme({
              token: res.authResponse.accessToken,
              id: res.authResponse.userID,
            });
          } else {
            // The person is not logged into your webpage or we are unable to tell.
          }
          // console.log(res, "--------------");
        });
        // Not logged into your webpage or we are unable to tell.
      }
    });
  } catch (error) {
    // console.log(error, "-----fbLogin------");
  }
};

// whatsapp 分享方式， text= 后面是分享的内容

// google 登陆
export const googleLogin = async (opt) => {
  console.log("googleCallbackFun", opt);
  if (!opt.access_token) return;
  const { code, data } = await googleLoginService({
    access_token: opt.access_token,
    coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
  });
  if (code === 0) {
    Store.commit("setTaken", {
      accessToken: data.token,
      refreshToken: data.refreshToken,
    });
    Store.dispatch("getUserInfo");
    Store.commit("setPopBox", { show: false, views: null });
    if (data.is_register) {
      Bus.$emit("loginSuccess", {
        type: "register",
        event: "google_register",
        ...data,
      });
    } else {
      Bus.$emit("loginSuccess", {
        type: "login",
        event: "google_login",
        ...data,
      });
    }
    setTimeout(() => {
      Bus.$emit("reload");
    }, 300);
  }
};

// 连接tronLink
export const getTronWeb = async () => {
  let tronWeb;
  const tronLink = window.tronLink;
  if (!tronLink) return;
  if (tronLink?.ready) {
    tronWeb = tronLink.tronWeb;
  } else {
    const res = await tronLink?.request({ method: "tron_requestAccounts" });
    if (res.code === 200) {
      tronWeb = tronLink.tronWeb;
    }
  }
  console.log("getTronWeb", tronLink, tronWeb);
  return tronWeb;
};
// https://docs-zh.tronlink.org/dapp/kai-shi-kai-fa
// tron 登陆
export const tronLogin = async (obj) => {
  const { address, message, signedString } = obj;
  console.log("tronLogin", address, encode(address));
  if (!address) return;
  const { code, data } = await tronLoginService({
    access_token: encode(address),
    message,
    signedString,
    coinCode: Store.getters.getPacketConfig?.appConfig?.coinCode,
  });
  if (code === 0) {
    Store.commit("setTaken", {
      accessToken: data.token,
      refreshToken: data.refreshToken,
    });
    Store.dispatch("getUserInfo");
    Store.commit("setPopBox", { show: false, views: null });
    if (data.is_register) {
      Bus.$emit("loginSuccess", {
        type: "register",
        event: "tron_register",
        ...data,
      });
    } else {
      Bus.$emit("loginSuccess", {
        type: "login",
        event: "tron_login",
        ...data,
      });
    }
    setTimeout(() => {
      Bus.$emit("reload");
    }, 300);
  }
};
